export type SignInProps = {
  waitlistRedirect?: boolean
}

export enum HelperTextStatus { EmailSent='emailSent', PasswordUpdated='passwordUpdated' }
